<template>
  <div class="attachment-view-box">
    <VueOfficeDocx
      v-if="attachmentType === 'document'"
      class="attachment-content-box"
      :src="docxContent"
      @rendered="renderedHandler"
      @error="errorHandler"
    />
    <VueOfficeExcel
      v-if="attachmentType === 'excel'"
      class="attachment-content-box"
      :src="excelContent"
      @rendered="renderedHandler"
      @error="errorHandler"
    />
    <VueOfficePdf
      v-if="attachmentType === 'pdf'"
      class="attachment-content-box"
      :src="pdfContent"
      @rendered="renderedHandler"
      @error="errorHandler"
    />
    <div class="text-box" v-if="attachmentType === 'text'">
      {{ textContent }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import "@vue-office/excel/lib/index.css";
import VueOfficePdf from "@vue-office/pdf";

export default {
  data() {
    return {
      attachmentType: "",
      textContent: "",
      docxContent: "",
      excelContent: "",
      pdfContent: "",
    };
  },
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf,
  },
  mounted() {
    this.handleAttachmentContent();
  },
  methods: {
    handleAttachmentContent() {
      let { attachmentUrl, attachmentType } = this.$route.query;
      this.attachmentType = attachmentType;
      if (attachmentType !== "text") {
        this.handleOfficeContent(attachmentType, attachmentUrl);
      } else {
        this.handleTextContent(attachmentUrl);
      }
    },
    handleOfficeContent(attachmentType, attachmentUrl) {
      switch (attachmentType) {
        case "document":
          this.docxContent = attachmentUrl;
          break;
        case "excel":
          this.excelContent = attachmentUrl;
          break;
        case "pdf":
          this.pdfContent = attachmentUrl;
      }
    },
    handleTextContent(attachmentUrl) {
      axios.get(attachmentUrl).then((result) => {
        if (result.status === 200) {
          this.textContent = result.data;
        }
      });
    },
    renderedHandler() {
      console.log("渲染完成");
    },
    errorHandler() {
      console.log("渲染失败");
    },
  },
};
</script>

<style lang="less" scoped>
.attachment-view-box {
  width: 100%;
  height: 100%;
  background: var(--bg-color);
  overflow-y: auto;

  .attachment-content-box {
    height: 100%;
  }

  .text-box {
    height: 100%;
    text-align: left;
    padding: 20px;
  }
}
</style>